import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import '@adornis/chemistry/elements/components/x-button.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { GlobalComponent } from '../../db/GlobalComponent';
import './marketing-global-component';

@customElement('marketing-not-found')
export class MarketingNotFound extends ChemistryLitElement {
  override render() {
    return html`
      <marketing-global-component .identifier=${GlobalComponent.identifier.NOT_FOUND_PAGE}></marketing-global-component>
    `;
  }
}
